import React from 'react';

import { Checkbox as MuiCheckbox, CheckboxProps, checkboxClasses } from '@mui/material';
import { styled } from '@mui/material/styles';

import { CheckIcon } from './icons/Check';
import { IndeterminateIcon } from './icons/Indeterminate';

export type { CheckboxProps };

export const Checkbox: React.ComponentType<CheckboxProps> = styled((props) => (
  <MuiCheckbox checkedIcon={<CheckIcon />} indeterminateIcon={<IndeterminateIcon />} {...props} />
))<CheckboxProps>(({ theme, color }) => ({
  display: 'flex',
  width: '22px',
  height: '22px',
  alignItems: 'flex-start',
  flexShrink: 0,
  borderRadius: '4px',
  border: `2px solid ${theme.palette.colors.border['neutral-primary']}`,
  margin: '1px',
  padding: 0,
  ...((!color || color === 'primary') && {
    [`&.Mui-checked`]: {
      borderColor: theme.palette.colors.border['action-primary'],
      backgroundColor: theme.palette.colors.bg['action-primary'],
    },
    [`&:hover`]: {
      [`&.Mui-checked`]: {
        borderColor: theme.palette.colors['bg-active']['action-primary'],
        backgroundColor: theme.palette.colors['bg-active']['action-primary'],
      },
    },
  }),
  ...(color === 'danger' && {
    borderColor: theme.palette.colors.border['danger-primary'],
    [`&.Mui-checked`]: {
      backgroundColor: theme.palette.colors.bg['danger-primary'],
    },
  }),
  [`&.Mui-disabled`]: {
    color: theme.palette.colors.special.bg.disabled,
    backgroundColor: theme.palette.colors.special.bg.disabled,
    border: 'none',
  },
  [`&:not(.Mui-disabled) .MuiSvgIcon-root`]: {
    width: '22px',
    height: '22px',
    marginTop: '-2px',
    color: theme.palette.colors.static.content['key-light'],
  },
  [`&.Mui-disabled .MuiSvgIcon-root`]: {
    width: '22px',
    height: '22px',
    marginTop: 0,
    color: theme.palette.colors.special.bg.disabled,
  },
  [`&.${checkboxClasses.indeterminate}`]: {
    [`&:not(.Mui-disabled) .MuiSvgIcon-root`]: {
      width: '12px',
      height: '2px',
      marginTop: '8px',
    },
    [`&.Mui-disabled .MuiSvgIcon-root`]: {
      width: '12px',
      height: '2px',
      marginTop: '10px',
    },
  },
}));
